const bundle = {
  close: () => 'Sulje',
  error: () => 'Virhe',
  warn: () => 'Varoitus',
  info: () => 'Tiedot',
  confirmation: () => 'Confirmation',
  progressIndeterminate: () => 'Käynnissä',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Välillä ' + p['FROM_SECTION'] + ' ja ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. Vastaavaa osaa ei löytynyt.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Valitse arvo painamalla Enter-näppäintä.',
  indexer_touchInstructionText: () =>
    'Siirry eletilaan kaksoisnapauttamalla ja painamalla ja säädä sitten arvoa vetämällä ylös- tai alaspäin.',
  inputPassword_show: () => 'Näytä salasana',
  inputPassword_hide: () => 'Piilota salasana',
  inputPassword_hidden: () => 'Salasana piilotettu',
  formControl_clear: () => 'Tyhjennä',
  formControl_loading: () => 'Ladataan',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Enimmäispituus ' + p['MAX_LENGTH'] + ' ylitetty.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' merkkiä jäljellä.',
  select_noMatchesFound: () => 'Vastineita ei löydy.',
  select_oneMatchFound: () => 'Yksi vastaavuus löydettiin',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' osumaa',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Vähintään ' + p['TOTAL_SIZE'] + ' osumaa',
  selectMultiple_showSelectedValues: () => 'Näytä vain valitut arvot.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' arvoa valittu.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Valintaruutu on valittu',
  selector_unselected: () => 'Valintaruutua ei ole valittu',
  userAssistance_learnMore: () => 'Lisätietoja',
  userAssistance_required: () => 'Pakollinen',
  filePicker_singleFileUploadError: () => 'Lataa yksi tiedosto kerrallaan',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Tyypin ' + p['fileType'] + ' tiedostoja ei voi ladata',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Seuraavien tyyppien tiedostoja ei voi ladata: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'tuntematon',
  filePicker_dropzonePrimaryText: () => 'Vedä ja pudota',
  filePicker_dropzoneSecondaryText: () => 'Valitse tiedosto tai vedä se tähän',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Valitse tai pudota tiedostot tähän',
  filePicker_addFiles: () => 'Lisää tiedostoja',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Lisäys',
  inputNumber_decrease: () => 'Vähennys',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Ei sisältöä',
  message_navigationFromMessagesRegion: () =>
    'Siirrytään viestialueelle. Siirry takaisin kohdistettuun elementtiin F6-näppäimellä.',
  message_navigationToMessagesRegion: () =>
    'Viestialueella on uusia viestejä. Siirry viimeisimmälle viestialueelle F6-näppäimellä.',
  messageToast_allMessagesClosed: () => 'Kaikki näyttöviestit on suljettu.'
};
export default bundle;
